import { getTextField } from '@lender/utils';
import { object } from 'yup';

import { DESCRIPTION_MAX_LENGTH, TITLE_MAX_LENGTH } from './AppraisalRevisionForm.constants';

export const schema = object().shape({
  title: getTextField({ isRequired: true }).max(
    TITLE_MAX_LENGTH,
    `Title must be at most ${TITLE_MAX_LENGTH} characters`,
  ),
  description: getTextField({ isRequired: true }).max(
    DESCRIPTION_MAX_LENGTH,
    `Description must be at most ${DESCRIPTION_MAX_LENGTH} characters`,
  ),
});
